export default {
  loading: false,
  shortcuts: false,
  routerJump: undefined,
  settingName: undefined,
  isLoggingOut: false
}
